<template>
  <div
      class="modal fade"
      :class="{ 'show d-block': isOpen }"
      tabindex="-1"
      role="dialog"
      style="background: rgba(0, 0, 0, 0.5);"
      v-if="isOpen"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content shadow-lg">

        <div class="modal-header bg-light">
          <h5 class="modal-title font-weight-bold text-dark">Вернуть мат. единицу на склад</h5>
          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="text-secondary small mb-3">
              Вы оформляете возврат мат. единицы на территорию Склада.
            </p>

            <!-- Поле: Дата операции -->
            <div class="form-group mb-0">
              <label class="form-label font-weight-bold small text-muted">Дата операции <span class="text-danger">*</span></label>
              <input
                  v-model="operationDate"
                  type="date"
                  class="form-control form-control-sm"
                  required
              >
            </div>
          </div>

          <div class="modal-footer bg-light justify-content-between">
            <button
                type="button"
                class="btn btn-secondary btn-sm"
                @click="closeModal"
                :disabled="isSubmitting"
            >
              Отмена
            </button>
            <button
                type="submit"
                class="btn btn-primary btn-sm"
                :disabled="isSubmitting"
            >
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              Подтвердить возврат
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "unit-geo-return-move-modal",
  props: {
    isOpen: { type: Boolean, default: false },
    unitId: { type: [Number, String], default: null },
    locationId: { type: [Number, String], default: null }
  },
  data() {
    return {
      isSubmitting: false,
      operationDate: new Date().toISOString().substr(0, 10)
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.operationDate = new Date().toISOString().substr(0, 10);
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submitForm() {
      if (!this.unitId || !this.locationId) return;
      this.isSubmitting = true;

      let uri = `/v1/units/geo-move-to-stockroom`;

      const payload = {
        id: this.unitId,
        geo_location_id: this.locationId,
        operation_date: this.operationDate
      };

      axios
          .post(uri, payload)
          .then(resp => {
            this.$emit("returned");
            this.closeModal();
            if (this.$store) {
              this.$store.dispatch("addNotification", {
                text: "Мат. единица успешно возвращена на склад!",
                time: 4,
                color: "success"
              });
            }
          })
          .catch(err => {
            const errorMsg = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : "Не удалось выполнить возврат";
            if (this.$store) {
              this.$store.dispatch("addNotification", { text: errorMsg, time: 6, color: "danger" });
            }
          })
          .finally(() => {
            this.isSubmitting = false;
          });
    }
  }
}
</script>
